module.exports = __webpack_public_path__ + "img/24.1748cc53.png";